export default __webpack_public_path__ + "static/media/SD-kumkuma-archana-img.30ea53ce.png";